import {Component} from '@angular/core'
import {SystemUpdateService} from '../../services/system-update.service'

@Component({
  selector: 'app-system-updates-panel',
  templateUrl: './system-updates-panel.component.html',
  styleUrls: ['./system-updates-panel.component.css'],
  standalone: false
})
export class SystemUpdatesPanelComponent {
  constructor(public systemUpdate: SystemUpdateService) {
  }
}
